import * as React from "react";
import styled from "styled-components";
import { useDrop } from "react-dnd";

export interface Props {
  onDrop?: (item: any) => void;
  enabled: boolean;
  showBorder?: boolean;
  flex?: boolean;
  children: React.ReactNode;
}

const StyledDroppablePile = styled.div<
  Props & { canDrop: boolean; isOver: boolean; isActive: boolean }
>`
  padding: 0.5em;
  border-color: #4f4f33;

  ${({ showBorder = true }) =>
    showBorder
      ? `border-width: 0.08em; border-style: dashed;`
      : `padding: 0.58em;`}

  ${({ isActive }) =>
    isActive && `border-color: white;`}

  border-radius: 0.15em;
  box-shadow: none;
  height: 3em;
  width: 2em;

  ${({ flex }) =>
    flex &&
    ` 
    display: flex;
    justify-content: center;`}
`;

const DroppablePile: React.FC<Props> = ({
  onDrop,
  enabled,
  showBorder = true,
  flex,
  children,
}) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "card",
    drop: onDrop,
    canDrop: () => enabled,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <StyledDroppablePile
      ref={drop}
      showBorder={showBorder}
      enabled={enabled}
      flex={flex}
      canDrop={canDrop}
      isOver={isOver}
      isActive={canDrop && isOver}
    >
      {children}
    </StyledDroppablePile>
  );
};

export default DroppablePile;
